import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _1d4b0d3b = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _74c2cc0f = () => interopDefault(import('../pages/coverage.vue' /* webpackChunkName: "pages/coverage" */))
const _0258f6c2 = () => interopDefault(import('../pages/ratings.vue' /* webpackChunkName: "pages/ratings" */))
const _067e6da4 = () => interopDefault(import('../pages/black-april/index.vue' /* webpackChunkName: "pages/black-april/index" */))
const _ff20f2d2 = () => interopDefault(import('../pages/black-friday/index.vue' /* webpackChunkName: "pages/black-friday/index" */))
const _3b023caf = () => interopDefault(import('../pages/black-september/index.vue' /* webpackChunkName: "pages/black-september/index" */))
const _2d6adef8 = () => interopDefault(import('../pages/charity/index.vue' /* webpackChunkName: "pages/charity/index" */))
const _020b900e = () => interopDefault(import('../pages/document-proof.vue' /* webpackChunkName: "pages/document-proof" */))
const _a971a394 = () => interopDefault(import('../pages/get-advice.vue' /* webpackChunkName: "pages/get-advice" */))
const _a8ab8d84 = () => interopDefault(import('../pages/b2b/index.vue' /* webpackChunkName: "pages/b2b/index" */))
const _837484da = () => interopDefault(import('../pages/iframe-offer-card.vue' /* webpackChunkName: "pages/iframe-offer-card" */))
const _6b3cae3c = () => interopDefault(import('../pages/maintenance.vue' /* webpackChunkName: "pages/maintenance" */))
const _4839997c = () => interopDefault(import('../pages/quiz.vue' /* webpackChunkName: "pages/quiz" */))
const _27a392d3 = () => interopDefault(import('../pages/test-page.vue' /* webpackChunkName: "pages/test-page" */))
const _e096e668 = () => interopDefault(import('../pages/test-redirect-page.vue' /* webpackChunkName: "pages/test-redirect-page" */))
const _d4a28ff6 = () => interopDefault(import('../pages/about-us.vue' /* webpackChunkName: "pages/about-us" */))
const _cbd8520c = () => interopDefault(import('../pages/unsubscribe.vue' /* webpackChunkName: "pages/unsubscribe" */))
const _16b90538 = () => interopDefault(import('../pages/how-it-works.vue' /* webpackChunkName: "pages/how-it-works" */))
const _99451ab8 = () => interopDefault(import('../pages/amp/document-proof.vue' /* webpackChunkName: "pages/amp/document-proof" */))
const _b502506c = () => interopDefault(import('../pages/black-friday/mobile-plans.vue' /* webpackChunkName: "pages/black-friday/mobile-plans" */))
const _7a3092e9 = () => interopDefault(import('../pages/black-friday/internet-plans.vue' /* webpackChunkName: "pages/black-friday/internet-plans" */))
const _0f935af0 = () => interopDefault(import('../pages/order/preview.vue' /* webpackChunkName: "pages/order/preview" */))
const _4d261eb6 = () => interopDefault(import('../pages/special-offers/request-cashback.vue' /* webpackChunkName: "pages/special-offers/request-cashback" */))
const _0df24b94 = () => interopDefault(import('../pages/compare/mobile/index.vue' /* webpackChunkName: "pages/compare/mobile/index" */))
const _3c4dc073 = () => interopDefault(import('../pages/compare/home/index.vue' /* webpackChunkName: "pages/compare/home/index" */))
const _72752c56 = () => interopDefault(import('../pages/b2b/fallstudie/apartment-service.vue' /* webpackChunkName: "pages/b2b/fallstudie/apartment-service" */))
const _62aba5a0 = () => interopDefault(import('../pages/b2b/fallstudie/kern-studer.vue' /* webpackChunkName: "pages/b2b/fallstudie/kern-studer" */))
const _bbc6f19e = () => interopDefault(import('../pages/b2b/fallstudie/sanoptis.vue' /* webpackChunkName: "pages/b2b/fallstudie/sanoptis" */))
const _1b04b4d4 = () => interopDefault(import('../pages/order/update/selfie.vue' /* webpackChunkName: "pages/order/update/selfie" */))
const _37e10990 = () => interopDefault(import('../pages/special-offers/amp/request-cashback.vue' /* webpackChunkName: "pages/special-offers/amp/request-cashback" */))
const _115f8e24 = () => interopDefault(import('../pages/compare/mobile/_slug.vue' /* webpackChunkName: "pages/compare/mobile/_slug" */))
const _3a971f2b = () => interopDefault(import('../pages/compare/home/_slug.vue' /* webpackChunkName: "pages/compare/home/_slug" */))
const _b4391630 = () => interopDefault(import('../pages/amp/_slug.vue' /* webpackChunkName: "pages/amp/_slug" */))
const _12ff02d3 = () => interopDefault(import('../pages/provider/_slug.vue' /* webpackChunkName: "pages/provider/_slug" */))
const _7eb8e54f = () => interopDefault(import('../pages/black-friday/_slug.vue' /* webpackChunkName: "pages/black-friday/_slug" */))
const _5b1b649c = () => interopDefault(import('../pages/order/_slug.vue' /* webpackChunkName: "pages/order/_slug" */))
const _0b859d1e = () => interopDefault(import('../pages/page/_slug.vue' /* webpackChunkName: "pages/page/_slug" */))
const _992b5b28 = () => interopDefault(import('../pages/partner/_slug.vue' /* webpackChunkName: "pages/partner/_slug" */))
const _346e9a1a = () => interopDefault(import('../pages/feedback/_type/_orderId.vue' /* webpackChunkName: "pages/feedback/_type/_orderId" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/de/",
    component: _1d4b0d3b,
    pathToRegexpOptions: {"strict":true},
    name: "index___de"
  }, {
    path: "/en/",
    component: _1d4b0d3b,
    pathToRegexpOptions: {"strict":true},
    name: "index___en"
  }, {
    path: "/fr/",
    component: _1d4b0d3b,
    pathToRegexpOptions: {"strict":true},
    name: "index___fr"
  }, {
    path: "/de/abdeckungskarte/",
    component: _74c2cc0f,
    pathToRegexpOptions: {"strict":true},
    name: "coverage___de"
  }, {
    path: "/de/bewertungen/",
    component: _0258f6c2,
    pathToRegexpOptions: {"strict":true},
    name: "ratings___de"
  }, {
    path: "/de/black-april/",
    component: _067e6da4,
    pathToRegexpOptions: {"strict":true},
    name: "black-april___de"
  }, {
    path: "/de/black-friday/",
    component: _ff20f2d2,
    pathToRegexpOptions: {"strict":true},
    name: "black-friday___de"
  }, {
    path: "/de/black-september/",
    component: _3b023caf,
    pathToRegexpOptions: {"strict":true},
    name: "black-september___de"
  }, {
    path: "/de/charity/",
    component: _2d6adef8,
    pathToRegexpOptions: {"strict":true},
    name: "charity___de"
  }, {
    path: "/de/document-proof/",
    component: _020b900e,
    pathToRegexpOptions: {"strict":true},
    name: "document-proof___de"
  }, {
    path: "/de/get-advice/",
    component: _a971a394,
    pathToRegexpOptions: {"strict":true},
    name: "get-advice___de"
  }, {
    path: "/de/handy-und-internet-abos-fuer-geschaeftskunden/",
    component: _a8ab8d84,
    pathToRegexpOptions: {"strict":true},
    name: "b2b___de"
  }, {
    path: "/de/iframe-offer-card/",
    component: _837484da,
    pathToRegexpOptions: {"strict":true},
    name: "iframe-offer-card___de"
  }, {
    path: "/de/maintenance/",
    component: _6b3cae3c,
    pathToRegexpOptions: {"strict":true},
    name: "maintenance___de"
  }, {
    path: "/de/quiz/",
    component: _4839997c,
    pathToRegexpOptions: {"strict":true},
    name: "quiz___de"
  }, {
    path: "/de/test-page/",
    component: _27a392d3,
    pathToRegexpOptions: {"strict":true},
    name: "test-page___de"
  }, {
    path: "/de/test-redirect-page/",
    component: _e096e668,
    pathToRegexpOptions: {"strict":true},
    name: "test-redirect-page___de"
  }, {
    path: "/de/ueber-uns/",
    component: _d4a28ff6,
    pathToRegexpOptions: {"strict":true},
    name: "about-us___de"
  }, {
    path: "/de/unsubscribe/",
    component: _cbd8520c,
    pathToRegexpOptions: {"strict":true},
    name: "unsubscribe___de"
  }, {
    path: "/de/wie-funktioniert-es/",
    component: _16b90538,
    pathToRegexpOptions: {"strict":true},
    name: "how-it-works___de"
  }, {
    path: "/en/about-us/",
    component: _d4a28ff6,
    pathToRegexpOptions: {"strict":true},
    name: "about-us___en"
  }, {
    path: "/en/black-april/",
    component: _067e6da4,
    pathToRegexpOptions: {"strict":true},
    name: "black-april___en"
  }, {
    path: "/en/black-friday/",
    component: _ff20f2d2,
    pathToRegexpOptions: {"strict":true},
    name: "black-friday___en"
  }, {
    path: "/en/black-september/",
    component: _3b023caf,
    pathToRegexpOptions: {"strict":true},
    name: "black-september___en"
  }, {
    path: "/en/charity/",
    component: _2d6adef8,
    pathToRegexpOptions: {"strict":true},
    name: "charity___en"
  }, {
    path: "/en/coverage/",
    component: _74c2cc0f,
    pathToRegexpOptions: {"strict":true},
    name: "coverage___en"
  }, {
    path: "/en/document-proof/",
    component: _020b900e,
    pathToRegexpOptions: {"strict":true},
    name: "document-proof___en"
  }, {
    path: "/en/get-advice/",
    component: _a971a394,
    pathToRegexpOptions: {"strict":true},
    name: "get-advice___en"
  }, {
    path: "/en/how-it-works/",
    component: _16b90538,
    pathToRegexpOptions: {"strict":true},
    name: "how-it-works___en"
  }, {
    path: "/en/iframe-offer-card/",
    component: _837484da,
    pathToRegexpOptions: {"strict":true},
    name: "iframe-offer-card___en"
  }, {
    path: "/en/maintenance/",
    component: _6b3cae3c,
    pathToRegexpOptions: {"strict":true},
    name: "maintenance___en"
  }, {
    path: "/en/quiz/",
    component: _4839997c,
    pathToRegexpOptions: {"strict":true},
    name: "quiz___en"
  }, {
    path: "/en/ratings/",
    component: _0258f6c2,
    pathToRegexpOptions: {"strict":true},
    name: "ratings___en"
  }, {
    path: "/en/test-page/",
    component: _27a392d3,
    pathToRegexpOptions: {"strict":true},
    name: "test-page___en"
  }, {
    path: "/en/test-redirect-page/",
    component: _e096e668,
    pathToRegexpOptions: {"strict":true},
    name: "test-redirect-page___en"
  }, {
    path: "/en/unsubscribe/",
    component: _cbd8520c,
    pathToRegexpOptions: {"strict":true},
    name: "unsubscribe___en"
  }, {
    path: "/fr/a-propos/",
    component: _d4a28ff6,
    pathToRegexpOptions: {"strict":true},
    name: "about-us___fr"
  }, {
    path: "/fr/black-april/",
    component: _067e6da4,
    pathToRegexpOptions: {"strict":true},
    name: "black-april___fr"
  }, {
    path: "/fr/black-friday/",
    component: _ff20f2d2,
    pathToRegexpOptions: {"strict":true},
    name: "black-friday___fr"
  }, {
    path: "/fr/black-september/",
    component: _3b023caf,
    pathToRegexpOptions: {"strict":true},
    name: "black-september___fr"
  }, {
    path: "/fr/charity/",
    component: _2d6adef8,
    pathToRegexpOptions: {"strict":true},
    name: "charity___fr"
  }, {
    path: "/fr/comment-ca-marche/",
    component: _16b90538,
    pathToRegexpOptions: {"strict":true},
    name: "how-it-works___fr"
  }, {
    path: "/fr/couverture/",
    component: _74c2cc0f,
    pathToRegexpOptions: {"strict":true},
    name: "coverage___fr"
  }, {
    path: "/fr/document-proof/",
    component: _020b900e,
    pathToRegexpOptions: {"strict":true},
    name: "document-proof___fr"
  }, {
    path: "/fr/get-advice/",
    component: _a971a394,
    pathToRegexpOptions: {"strict":true},
    name: "get-advice___fr"
  }, {
    path: "/fr/iframe-offer-card/",
    component: _837484da,
    pathToRegexpOptions: {"strict":true},
    name: "iframe-offer-card___fr"
  }, {
    path: "/fr/maintenance/",
    component: _6b3cae3c,
    pathToRegexpOptions: {"strict":true},
    name: "maintenance___fr"
  }, {
    path: "/fr/quiz/",
    component: _4839997c,
    pathToRegexpOptions: {"strict":true},
    name: "quiz___fr"
  }, {
    path: "/fr/ratings/",
    component: _0258f6c2,
    pathToRegexpOptions: {"strict":true},
    name: "ratings___fr"
  }, {
    path: "/fr/test-page/",
    component: _27a392d3,
    pathToRegexpOptions: {"strict":true},
    name: "test-page___fr"
  }, {
    path: "/fr/test-redirect-page/",
    component: _e096e668,
    pathToRegexpOptions: {"strict":true},
    name: "test-redirect-page___fr"
  }, {
    path: "/fr/unsubscribe/",
    component: _cbd8520c,
    pathToRegexpOptions: {"strict":true},
    name: "unsubscribe___fr"
  }, {
    path: "/de/amp/document-proof/",
    component: _99451ab8,
    pathToRegexpOptions: {"strict":true},
    name: "amp-document-proof___de"
  }, {
    path: "/de/black-friday/handy-abos/",
    component: _b502506c,
    pathToRegexpOptions: {"strict":true},
    name: "black-friday-mobile-plans___de"
  }, {
    path: "/de/black-friday/internet-abos/",
    component: _7a3092e9,
    pathToRegexpOptions: {"strict":true},
    name: "black-friday-internet-plans___de"
  }, {
    path: "/de/order/preview/",
    component: _0f935af0,
    pathToRegexpOptions: {"strict":true},
    name: "order-preview___de"
  }, {
    path: "/de/special_offers/get_cashback/",
    component: _4d261eb6,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-request-cashback___de"
  }, {
    path: "/de/vergleichen/handy/",
    component: _0df24b94,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mobile___de"
  }, {
    path: "/de/vergleichen/home/",
    component: _3c4dc073,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home___de"
  }, {
    path: "/en/amp/document-proof/",
    component: _99451ab8,
    pathToRegexpOptions: {"strict":true},
    name: "amp-document-proof___en"
  }, {
    path: "/en/black-friday/internet-plans/",
    component: _7a3092e9,
    pathToRegexpOptions: {"strict":true},
    name: "black-friday-internet-plans___en"
  }, {
    path: "/en/black-friday/mobile-plans/",
    component: _b502506c,
    pathToRegexpOptions: {"strict":true},
    name: "black-friday-mobile-plans___en"
  }, {
    path: "/en/compare/home/",
    component: _3c4dc073,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home___en"
  }, {
    path: "/en/compare/mobile/",
    component: _0df24b94,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mobile___en"
  }, {
    path: "/en/order/preview/",
    component: _0f935af0,
    pathToRegexpOptions: {"strict":true},
    name: "order-preview___en"
  }, {
    path: "/en/special_offers/get_cashback/",
    component: _4d261eb6,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-request-cashback___en"
  }, {
    path: "/fr/amp/document-proof/",
    component: _99451ab8,
    pathToRegexpOptions: {"strict":true},
    name: "amp-document-proof___fr"
  }, {
    path: "/fr/black-friday/abonnements-internet/",
    component: _7a3092e9,
    pathToRegexpOptions: {"strict":true},
    name: "black-friday-internet-plans___fr"
  }, {
    path: "/fr/black-friday/abonnements-mobiles/",
    component: _b502506c,
    pathToRegexpOptions: {"strict":true},
    name: "black-friday-mobile-plans___fr"
  }, {
    path: "/fr/comparer/home/",
    component: _3c4dc073,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home___fr"
  }, {
    path: "/fr/comparer/mobile/",
    component: _0df24b94,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mobile___fr"
  }, {
    path: "/fr/order/preview/",
    component: _0f935af0,
    pathToRegexpOptions: {"strict":true},
    name: "order-preview___fr"
  }, {
    path: "/fr/special_offers/get_cashback/",
    component: _4d261eb6,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-request-cashback___fr"
  }, {
    path: "/de/handy-und-internet-abos-fuer-geschaeftskunden/fallstudie/aas/",
    component: _72752c56,
    pathToRegexpOptions: {"strict":true},
    name: "b2b-fallstudie-apartment-service___de"
  }, {
    path: "/de/handy-und-internet-abos-fuer-geschaeftskunden/fallstudie/kernstuder/",
    component: _62aba5a0,
    pathToRegexpOptions: {"strict":true},
    name: "b2b-fallstudie-kern-studer___de"
  }, {
    path: "/de/handy-und-internet-abos-fuer-geschaeftskunden/fallstudie/sanoptis/",
    component: _bbc6f19e,
    pathToRegexpOptions: {"strict":true},
    name: "b2b-fallstudie-sanoptis___de"
  }, {
    path: "/de/order/update/selfie/",
    component: _1b04b4d4,
    pathToRegexpOptions: {"strict":true},
    name: "order-update-selfie___de"
  }, {
    path: "/de/special-offers/amp/request-cashback/",
    component: _37e10990,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-amp-request-cashback___de"
  }, {
    path: "/en/order/update/selfie/",
    component: _1b04b4d4,
    pathToRegexpOptions: {"strict":true},
    name: "order-update-selfie___en"
  }, {
    path: "/en/special-offers/amp/request-cashback/",
    component: _37e10990,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-amp-request-cashback___en"
  }, {
    path: "/fr/order/update/selfie/",
    component: _1b04b4d4,
    pathToRegexpOptions: {"strict":true},
    name: "order-update-selfie___fr"
  }, {
    path: "/fr/special-offers/amp/request-cashback/",
    component: _37e10990,
    pathToRegexpOptions: {"strict":true},
    name: "special-offers-amp-request-cashback___fr"
  }, {
    path: "/de/vergleichen/handy/:slug/",
    component: _115f8e24,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mobile-slug___de"
  }, {
    path: "/de/vergleichen/home/:slug/",
    component: _3a971f2b,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home-slug___de"
  }, {
    path: "/en/compare/home/:slug/",
    component: _3a971f2b,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home-slug___en"
  }, {
    path: "/en/compare/mobile/:slug/",
    component: _115f8e24,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mobile-slug___en"
  }, {
    path: "/fr/comparer/home/:slug/",
    component: _3a971f2b,
    pathToRegexpOptions: {"strict":true},
    name: "compare-home-slug___fr"
  }, {
    path: "/fr/comparer/mobile/:slug/",
    component: _115f8e24,
    pathToRegexpOptions: {"strict":true},
    name: "compare-mobile-slug___fr"
  }, {
    path: "/de/amp/:slug?/",
    component: _b4391630,
    pathToRegexpOptions: {"strict":true},
    name: "amp-slug___de"
  }, {
    path: "/de/anbieter/:slug/",
    component: _12ff02d3,
    pathToRegexpOptions: {"strict":true},
    name: "provider-slug___de"
  }, {
    path: "/de/black-friday/:slug?/",
    component: _7eb8e54f,
    pathToRegexpOptions: {"strict":true},
    name: "black-friday-slug___de"
  }, {
    path: "/de/order/:slug?/",
    component: _5b1b649c,
    pathToRegexpOptions: {"strict":true},
    name: "order-slug___de"
  }, {
    path: "/de/page/:slug?/",
    component: _0b859d1e,
    pathToRegexpOptions: {"strict":true},
    name: "page-slug___de"
  }, {
    path: "/de/partner/:slug/",
    component: _992b5b28,
    pathToRegexpOptions: {"strict":true},
    name: "partner-slug___de"
  }, {
    path: "/en/amp/:slug?/",
    component: _b4391630,
    pathToRegexpOptions: {"strict":true},
    name: "amp-slug___en"
  }, {
    path: "/en/black-friday/:slug?/",
    component: _7eb8e54f,
    pathToRegexpOptions: {"strict":true},
    name: "black-friday-slug___en"
  }, {
    path: "/en/order/:slug?/",
    component: _5b1b649c,
    pathToRegexpOptions: {"strict":true},
    name: "order-slug___en"
  }, {
    path: "/en/page/:slug?/",
    component: _0b859d1e,
    pathToRegexpOptions: {"strict":true},
    name: "page-slug___en"
  }, {
    path: "/en/partner/:slug/",
    component: _992b5b28,
    pathToRegexpOptions: {"strict":true},
    name: "partner-slug___en"
  }, {
    path: "/en/provider/:slug/",
    component: _12ff02d3,
    pathToRegexpOptions: {"strict":true},
    name: "provider-slug___en"
  }, {
    path: "/fr/amp/:slug?/",
    component: _b4391630,
    pathToRegexpOptions: {"strict":true},
    name: "amp-slug___fr"
  }, {
    path: "/fr/black-friday/:slug?/",
    component: _7eb8e54f,
    pathToRegexpOptions: {"strict":true},
    name: "black-friday-slug___fr"
  }, {
    path: "/fr/operateur/:slug/",
    component: _12ff02d3,
    pathToRegexpOptions: {"strict":true},
    name: "provider-slug___fr"
  }, {
    path: "/fr/order/:slug?/",
    component: _5b1b649c,
    pathToRegexpOptions: {"strict":true},
    name: "order-slug___fr"
  }, {
    path: "/fr/page/:slug?/",
    component: _0b859d1e,
    pathToRegexpOptions: {"strict":true},
    name: "page-slug___fr"
  }, {
    path: "/fr/partenaire/:slug/",
    component: _992b5b28,
    pathToRegexpOptions: {"strict":true},
    name: "partner-slug___fr"
  }, {
    path: "/de/feedback/:type?/:orderId?/",
    component: _346e9a1a,
    pathToRegexpOptions: {"strict":true},
    name: "feedback-type-orderId___de"
  }, {
    path: "/en/feedback/:type?/:orderId?/",
    component: _346e9a1a,
    pathToRegexpOptions: {"strict":true},
    name: "feedback-type-orderId___en"
  }, {
    path: "/fr/feedback/:type?/:orderId?/",
    component: _346e9a1a,
    pathToRegexpOptions: {"strict":true},
    name: "feedback-type-orderId___fr"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
